import { ApprovalsActionType, APPROVAL_PROP } from "./constants";

export const getDefaultState = () => ({
  editApproval: {},
  table: {
    orderBy: {
      col: APPROVAL_PROP.FNAME,
      order: "asc",
    },
    search: "",
    limit: 10,
    offset: 0,
    filters: [],
  },
  approvals: [],
  total: 0,
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case ApprovalsActionType.SET_APPROVALS:
      return setApprovalsData(state, action);
    case ApprovalsActionType.SET_ORDER_BY:
      return setOrderBy(state, action);
    case ApprovalsActionType.SET_PAGING_OPT:
      return setPagingOptions(state, action);
    case ApprovalsActionType.SET_PAGE_OFFSET:
      return setPagingOffset(state, action);
    case ApprovalsActionType.SET_FILTER:
      return setFilter(state, action);
    case ApprovalsActionType.SET_SEARCH_TEXT:
      return setSearchText(state, action);
    case ApprovalsActionType.SET_EDIT_APPROVAL:
      return setEditApproval(state, action);
    default:
      return state;
  }
};

const setApprovalsData = (state, { approvals }) => {
  return {
    ...state,
    approvals: approvals.rows,
    total: approvals.total,
  };
};
function setSearchText(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      search: action.search,
    },
  };
}

function setFilter(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      filters: action.filters,
    },
  };
}

function setPagingOffset(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      offset: action.offset,
    },
  };
}

function setPagingOptions(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      limit: action.paging.limit,
      offset: action.paging.offset,
    },
  };
}

function setOrderBy(state, action) {
  return {
    ...state,
    table: {
      ...state.table,
      orderBy: action.orderBy,
    },
  };
}

function setEditApproval(state, { data }) {
  return {
    ...state,
    editApproval: data,
  };
}
